<app-spinner></app-spinner>

<div class="mx-auto" style="width: 82%">

  <a routerLink="/admin/userform/create/">
    <button type="button" class="btn btn-primary mb-5">Benutzer Erstellen</button>
  </a>

  <table class="table top">
    <thead>
    <tr>
      <th scope="col" class="pointer" (click)="this.sortTablebyColum(tablehead.sort_name)"
          *ngFor="let tablehead of this.tableheader">
        {{ tablehead.display_name }}
        <i *ngIf="this.lastsort === tablehead.sort_name"
           [ngClass]="{'bi-arrow-up': this.lastsorttype === 'DESC', 'bi-arrow-down': this.lastsorttype === 'ASC'}"
           class="bi"></i>
      </th>

      <th>Aktionen</th>

    </tr>
    </thead>
    <tbody>
    <tr (click)="Helper.TableSelect($event)" *ngFor="let user of this.users | async">
      <td>{{ user.uuid }}</td>
      <td>{{ user.username }}</td>
      <td>{{ user.name }}</td>
      <td>{{ user.lastname }}</td>
      <td>{{ user.customer_name ? user.customer_name : "N/A" }}</td>
      <td>
        <input type="checkbox" name="" id="checkbox-verified-{{user.uuid}}"
               [disabled]="!PermissionsHelper.hasPermission('staff.user.edit') || this.tokenStorage.getUser().uuid === user.uuid"
               class="checkbox-slider" (click)="this.changeStatus($event,user.uuid, 'verified')"
               [checked]="user.verified">
        <label for="checkbox-verified-{{user.uuid}}"></label>
      </td>
      <td>
        <input type="checkbox" name="" id="checkbox-disabled-{{user.uuid}}"
               [disabled]="!PermissionsHelper.hasPermission('staff.user.edit') || this.tokenStorage.getUser().uuid === user.uuid"
               class="checkbox-slider" (click)="this.changeStatus($event,user.uuid, 'disabled')"
               [checked]="user.disabled">
        <label for="checkbox-disabled-{{user.uuid}}"></label>
      </td>
      <td>{{ user.last_login ? Helper.formatDate(user.last_login) : "N/A" }}</td>
      <td>{{ Helper.formatDate(user.creation_date) }}</td>
      <td [innerHTML]="this.getPermissionList(user.permissions) | safeHtml"></td>
      <td>
        <button class="btn btn-primary me-2" [disabled]="!PermissionsHelper.hasPermission('staff.user.edit')"
                (click)="this.router.navigateByUrl('/admin/userform/edit/' + user.uuid)">Benutzer Bearbeiten
        </button>
      </td>
    </tr>
    </tbody>
  </table>
</div>
